"use strict";

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  &:disabled {\n    ", ";\n  }\n  ", ";\n  &:focus {\n    ", ";\n  }\n  ", ";\n  &:hover {\n    ", ";\n  }\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 8px 40px 0 rgba(170, 187, 187, 0.25);\n  position: relative;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 8px 16px 0 rgba(170, 187, 187, 0.5);\n  position: relative;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 8px 16px 0 rgba(170, 187, 187, 0.5);\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 2px dashed ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surface = exports.floating = exports.shadow = exports.selected = exports.pressed = exports.hover = exports.focus = exports.disabled = exports.rested = void 0;

var _core = require("@emotion/core");

var _palette = require("../palette");

var surfaceRested = function surfaceRested(_ref) {
  var theme = _ref.theme;
  return (0, _core.css)(_templateObject(), theme.uSurfaceRested, (0, _palette.color)(theme, 'neutral03'));
};

exports.rested = surfaceRested;

var surfaceDisabled = function surfaceDisabled(_ref2) {
  var theme = _ref2.theme;
  return (0, _core.css)(_templateObject2(), theme.uSurfaceDisabled, (0, _palette.color)(theme, 'neutral04'));
};

exports.disabled = surfaceDisabled;

var surfaceFocus = function surfaceFocus(_ref3) {
  var theme = _ref3.theme;
  return (0, _core.css)(_templateObject3(), theme.uSurfaceRested, (0, _palette.color)(theme, 'secondary03'));
};

exports.focus = surfaceFocus;

var surfaceHover = function surfaceHover(_ref4) {
  var theme = _ref4.theme;
  return (0, _core.css)(_templateObject4(), theme.uSurfaceHover, (0, _palette.color)(theme, 'secondary05'));
};

exports.hover = surfaceHover;

var surfacePressed = function surfacePressed(_ref5) {
  var theme = _ref5.theme;
  return (0, _core.css)(_templateObject5(), theme.uSurfacePressed, (0, _palette.color)(theme, 'secondary05'));
};

exports.pressed = surfacePressed;

var surfaceSelected = function surfaceSelected(_ref6) {
  var theme = _ref6.theme;
  return (0, _core.css)(_templateObject6(), theme.uSurfaceSelected, (0, _palette.color)(theme, 'secondary05'));
};

exports.selected = surfaceSelected;

var surfaceShadow = function surfaceShadow(_ref7) {
  var theme = _ref7.theme;
  return (0, _core.css)(_templateObject7(), theme.uSurfaceShadow, (0, _palette.color)(theme, 'neutral03'));
};

exports.shadow = surfaceShadow;

var surfaceFloating = function surfaceFloating(_ref8) {
  var theme = _ref8.theme;
  return (0, _core.css)(_templateObject8(), theme.uSurfaceFloating, (0, _palette.color)(theme, 'neutral03'));
};

exports.floating = surfaceFloating;

var surface = function surface(_ref9) {
  var disabled = _ref9.disabled,
      focus = _ref9.focus,
      hover = _ref9.hover,
      pressed = _ref9.pressed,
      selected = _ref9.selected,
      shadow = _ref9.shadow,
      floating = _ref9.floating,
      props = _objectWithoutProperties(_ref9, ["disabled", "focus", "hover", "pressed", "selected", "shadow", "floating"]);

  return (0, _core.css)(_templateObject9(), surfaceRested(props), disabled && surfaceDisabled(props), surfaceDisabled(props), focus && surfaceFocus(props), surfaceFocus(props), hover && surfaceHover(props), surfaceHover(props), pressed && surfacePressed(props), selected && surfaceSelected(props), shadow && surfaceShadow(props), floating && surfaceFloating(props));
};

exports.surface = surface;